module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [(_vm.raceIdToNotification) ? _c('modal-one-signal', {
    attrs: {
      "race-id": _vm.raceIdToNotification
    },
    on: {
      "close-modal": _vm.closeOneSignal
    }
  }) : _vm._e(), _vm._v(" "), _c('race-header', {
    staticClass: "new-races-top",
    attrs: {
      "title": "Races"
    }
  }, [_c('router-link', {
    staticClass: "btn btn--primary new-race-btn",
    attrs: {
      "slot": "actions",
      "to": "/admin/races/add",
      "id": "newrace"
    },
    slot: "actions"
  }, [_vm._v("+ New Race")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table--full"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.races), function(race) {
    return _c('tr', {
      key: race.id
    }, [_c('td', {
      attrs: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(race.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "250px"
      }
    }, [_vm._v(_vm._s(race.description))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "130px"
      }
    }, [_vm._v(_vm._s(race.duration) + " minutes")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm.getStatusRace(race)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "260px"
      }
    }, [_vm._v(_vm._s(race.type))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "270px"
      }
    }, [_vm._v(_vm._s(_vm._f("date")(race.date)))]), _vm._v(" "), _c('td', {
      staticClass: "race-operation",
      attrs: {
        "width": "250px"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeRaceId != race.id || _vm.activeRaceId == 0),
        expression: "activeRaceId!=race.id ||activeRaceId==0"
      }],
      attrs: {
        "id": "wrapper"
      }
    }, [(race.startDate === null) ? _c('router-link', {
      staticClass: "btn btn--primary btn--block cbutton",
      attrs: {
        "to": {
          path: ("/admin/races/edit/" + (race.id))
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeRaceId != race.id),
        expression: "activeRaceId!=race.id "
      }],
      staticClass: "btn btn--danger btn--block cbutton",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "id": "delete2"
      },
      on: {
        "click": function($event) {
          _vm.handleDelete(race)
        }
      }
    }, [_vm._v("Delete\n            ")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteMode),
        expression: "deleteMode"
      }],
      staticClass: "confirmation"
    }, [(_vm.activeRaceId == race.id) ? _c('span', [_c('label', [_vm._v("Sure?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn--primary ",
      on: {
        "click": function($event) {
          _vm.deleteRaceSelected(race, _vm.event)
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": _vm.Clear
      }
    }, [_vm._v("No")])]) : _vm._e()])])])
  }))]), _vm._v(" "), (_vm.showDebugOptions) ? _c('debug-race-creator') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-053ed2bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/List.vue
// module id = 1764
// module chunks = 1